import { useState } from "react";
import locale from "localization";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import { Title } from "components/commons";
import { expensesMapper } from "././shift-records-details-cash-non-cash.mapper";
import { expensesColumn } from "./shift-records-details-cash-non-cash-column";
import { initialFilterState } from "modules/shift-records/shift-records-filter.state";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import ImageCarousel from "components/commons/image-carousel/image-carousel";
import { useAlert } from "hooks";

const ShiftDetailsExpense = ({ shift }) => {
  const [imageUrl, setImageUrl] = useState("");
  const { addAlert } = useAlert();

  const { table } = useDataTable({
    value: shift?.expense,
    filter: { initialState: initialFilterState(), mapper: (val) => val },
    table: {
      key: "expense",
      name: "expense",
      mapper: (val) =>
        expensesMapper({
          val,
          onClickViewSlip: (imageUrl) => {
            if (!imageUrl) {
              return addAlert({
                title: "Oops! No Image to Show",
                subtitle: "This image isn't available right now. Please check back later.",
                type: "error",
                interval: 3000,
              });
            }
            setImageUrl(imageUrl);
          },
        }),
      columns: expensesColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.expenses}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
        <ImageCarousel value={imageUrl} onClose={() => setImageUrl("")} />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsExpense;
